import { render, staticRenderFns } from "./PosterManagement.vue?vue&type=template&id=3d9f54ec&scoped=true"
import script from "./PosterManagement.vue?vue&type=script&lang=js"
export * from "./PosterManagement.vue?vue&type=script&lang=js"
import style0 from "./PosterManagement.vue?vue&type=style&index=0&id=3d9f54ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f54ec",
  null
  
)

export default component.exports